import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
const moment = require('moment');
const classnames = require('classnames');

const Modal = require('../../../deploynaut/js/Modal.jsx');
const form = require('../../../deploynaut/js/Form.jsx');

class SecuritySettingsModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			SecurityID: this.props.securityID,
			enabled: this.props.model.Enabled,
			gracePeriod: this.props.model.GracePeriod,
		};
	}

	toggleMfa() {
		this.setState({
			enabled: !this.state.enabled,
			gracePeriod: null,
		});
	}

	handleChange(date) {
		let newDate = null;
		if (date) {
			newDate = moment(date).format('YYYY-MM-DD HH:mm:ss');
		}

		this.setState({
			gracePeriod: newDate
		});
	}

	render() {
		let mfaLabel = "Require multi-factor authentication for team members ";
		let momentDate = moment(this.state.gracePeriod);

		let gracePeriodClasses = classnames({
			'form-group': true,
			'hide': !this.state.enabled,
		});

		// Update the moment locale to format the mfaLabel based on the relative time of the grace period
		moment.updateLocale(moment.locale(), {
			relativeTime: {
				future: "in %s time",
				m:  "a minutes",
				h:  "an hours",
				d:  "a days",
				M:  "a months",
				y:  "a years",
			}
		});

		// Tack on the relative time for the date, e.g "Require MFA *in 15 days time*
		if (momentDate.isValid() && momentDate.isAfter(moment())) {
			mfaLabel += moment(this.state.gracePeriod).fromNow();
		}

		return (
			<Modal
				closeHandler={this.props.closeHandler}
				closeTitle="&#215;"
				title="Security settings"
				large={false}
			>
				<form.Form
					ref="securitySettingsForm"
					url={this.props.model.SecurityURL}
					securityID={this.state.SecurityID}
					buttonTitle="Save"
					buttonSubmittingTitle="Saving"
					afterSuccess={this.props.closeHandler}
				>
					<div className="form-group">
						<label htmlFor="MFARequired" className="checkbox">
							<form.Checkbox
								name="MFARequired"
								value={this.state.enabled}
								label={mfaLabel}
								onChange={this.toggleMfa.bind(this)}
							/>
						</label>
					</div>

					<div className={gracePeriodClasses}>
						<label className="MFA-grace-period" htmlFor="MFAGracePeriod">Allow a grace period to set up multi-factor authentication until:</label>
						<DatePicker
							className="form-control"
							name="MFAGracePeriod"
							id="MFAGracePeriod"
							disabled={!this.state.enabled}
							selected={Date.parse(this.state.gracePeriod)}
							onChange={this.handleChange.bind(this)}
							isClearable={true}
							dateFormat="dd/MM/yyyy"
						/>
						<div className="help-text">If a grace period is set, team members will be encouraged to setup multi-factor authentication when they log in and can skip setup up until the grace period date.</div>
					</div>

					<form.Hidden name="MFAGracePeriodValue" value={this.state.gracePeriod} />
				</form.Form>
			</Modal>
		);
	}
}

module.exports = SecuritySettingsModal;


